import { useEditor, useNode } from "@craftjs/core";
import { useRef } from "react";
import ContentEditable from "react-contenteditable";
import Settings from "./Settings";

interface HeadingProps {
    htmlId?: string;
    text: string;
}

const DownloadsHeading = ({ htmlId, text }: Partial<HeadingProps>) => {
    const editableRef = useRef<HTMLDivElement | null>(null);

    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode((node) => ({
        parentNodeId: node.data.parent,
    }));

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    return (
        <div ref={(ref) => connect(ref!)}>
            <ContentEditable
                id={htmlId}
                html={text || ""}
                innerRef={editableRef}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((props: any) => (props.text = e.target.value), 500);
                }}
                tagName={`h2`}
                className="leading-16"
            />
        </div>
    );
};

export default DownloadsHeading;

DownloadsHeading.craft = {
    displayName: "Heading",
    props: {
        text: "Text",
    },
    related: {
        settings: Settings,
    },
};
